export const COINS_DEFAUT = [[0.08, 0.08], [0.92, 0.08], [0.92, 0.92], [0.08, 0.92]];
export const CARTES = ['cni_passeport', 'permis_cotier', 'permis_fluvial', 'crr', 'carte_pro', 'permis'];
export const MULTI_PAGES = ['cv'];

// Photo → canvas réduit (orientation EXIF appliquée par le navigateur)
export const chargerPhoto = (file, max = 2400) => new Promise((resolve, reject) => {
  const url = URL.createObjectURL(file);
  const img = new Image();
  img.onload = () => {
    const r = Math.min(1, max / Math.max(img.naturalWidth, img.naturalHeight));
    const canvas = document.createElement('canvas');
    canvas.width = Math.round(img.naturalWidth * r);
    canvas.height = Math.round(img.naturalHeight * r);
    canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
    URL.revokeObjectURL(url);
    resolve(canvas);
  };
  img.onerror = () => { URL.revokeObjectURL(url); reject(new Error('Image illisible')); };
  img.src = url;
});

export const canvasEnBlob = (canvas, qualite = 0.9) => new Promise((resolve) => canvas.toBlob(resolve, 'image/jpeg', qualite));

export const preparerPage = async (file) => {
  const canvas = await chargerPhoto(file);
  const blob = await canvasEnBlob(canvas);
  return { blob, url: URL.createObjectURL(blob), w: canvas.width, h: canvas.height, coins: null, rotation: 0 };
};

export const compresserImage = async (file, max = 2000, qualite = 0.85) => {
  const blob = await canvasEnBlob(await chargerPhoto(file, max), qualite);
  return new File([blob], `${(file.name || 'photo').replace(/\.[^.]+$/, '')}.jpg`, { type: 'image/jpeg' });
};

export const base64EnFichier = (b64, nom, type) => {
  const bin = atob(b64);
  const octets = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i += 1) octets[i] = bin.charCodeAt(i);
  return new File([octets], nom, { type });
};
